import firebase from "@firebase/app";
import "@firebase/auth";
import "@firebase/database";

import firebase_config from "@/config";

firebase.initializeApp(firebase_config);

export default firebase;
